export const PAYMENT_ROUTES = {
  LIST: '/payments',
  BANKS: '/payments/banks',
  REMITTANCES: '/payments/remittances',
  REMITTANCES_ADD: '/payments/remittances/add',
  REMITTANCES_DETAIL: '/payments/remittances/:id/detail',
  REMITTANCES_UPDATE_ADD_DOCUMENTS: '/payments/remittances/:id/add-documents',
};
